import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShiftTimelineUnassignedRegionState } from '@wilson/shift-timeline/state';

@Pipe({
  name: 'getJobName',
  standalone: true,
})
export class GetJobNamePipe implements PipeTransform {
  private store = inject(Store);

  transform(id: string) {
    return this.store.select(ShiftTimelineUnassignedRegionState.getJobName(id));
  }
}
